import { render } from "./BrandDerGrazer.vue?vue&type=template&id=033ac88f"
import script from "./BrandDerGrazer.vue?vue&type=script&lang=ts"
export * from "./BrandDerGrazer.vue?vue&type=script&lang=ts"

import "./BrandDerGrazer.vue?vue&type=style&index=0&id=033ac88f&lang=scss"
script.render = render

export default script